<template>
  <div class="virtual-exhibition">
    <div class="exhibition-header">
      <h1>Virtual Exhibition 虛擬展覽</h1>
      <p>Explore our immersive virtual exhibition space</p>
    </div>
    
    <div class="exhibition-container">
      <iframe 
        :src="virtualExhibitionUrl"
        class="exhibition-frame"
        frameborder="0"
        allowfullscreen
        title="Virtual Exhibition"
      ></iframe>
    </div>
    
    <div class="exhibition-info">
      <div class="info-card">
        <h3>展覽導覽 Navigation Guide</h3>
        <ul>
          <li>使用滑鼠環顧四周 Use your mouse to look around</li>
          <li>點擊並拖曳以旋轉視角 Click and drag to rotate the view</li>
          <li>使用滾輪放大/縮小 Use scroll wheel to zoom in/out</li>
          <li>點擊熱點探索不同區域 Click on hotspots to explore different areas</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VirtualExhibitionPage',
  computed: {
    virtualExhibitionUrl() {
      // 使用構建時注入的 BASE_URL，確保在生產環境與開發環境都能正確解析
      const baseUrl = process.env.BASE_URL || '/';
      return `${baseUrl}virtual-exhibition/index.html`;
    }
  }
}
</script>

<style scoped>
.virtual-exhibition {
  min-height: 100vh;
  background: white;
  padding: 20px;
}

.exhibition-header {
  text-align: center;
  color: #004D6B;
  margin-bottom: 30px;
  padding: 40px 20px;
}

.exhibition-header h1 {
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
}

.exhibition-header p {
  font-size: 1.2rem;
  opacity: 0.9;
  max-width: 600px;
  margin: 0 auto;
}

.exhibition-container {
  max-width: 1200px;
  margin: 0 auto;
  background: white;
  border-radius: 15px;
  padding: 20px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
  margin-bottom: 40px;
}

.exhibition-frame {
  width: 100%;
  height: 70vh;
  min-height: 500px;
  border-radius: 10px;
  overflow: hidden;
}

.exhibition-info {
  max-width: 1200px;
  margin: 0 auto;
}

.info-card {
  background: rgba(255, 255, 255, 0.95);
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.info-card h3 {
  color: #004D6B;
  font-size: 1.5rem;
  margin-bottom: 20px;
  text-align: center;
}

.info-card ul {
  list-style: none;
  padding: 0;
  max-width: 500px;
  margin: 0 auto;
}

.info-card li {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  color: #666;
  position: relative;
  padding-left: 30px;
}

.info-card li:before {
  content: "→";
  position: absolute;
  left: 0;
  color: rgba(240, 131, 30);
  font-weight: bold;
}

.info-card li:last-child {
  border-bottom: none;
}

@media (max-width: 768px) {
  .virtual-exhibition {
    padding: 10px;
  }
  
  .exhibition-header h1 {
    font-size: 2rem;
  }
  
  .exhibition-container {
    padding: 15px;
  }
  
  .exhibition-frame {
    height: 50vh;
    min-height: 400px;
  }
  
  .info-card {
    padding: 20px;
  }
}
</style> 